__webpack_require__.p = "/views-table/referrals-hub/";